<div id="inicio" style="color: white; margin-bottom: -20px;">s</div>
<app-template>
    <div class="fad-desktop" *ngIf=" isMobile === false && isTablet === false ">
        <div class="principal-support">
            <div class="container max-width">
                <div class="info">
                    <h1><p class="principal">
                        ¿Tienes alguna duda <br> o <span>necesitas ayuda</span>?
                    </p></h1>
                    <div class="description">
                        <h2>Ponte en contacto con uno <br>de nuestros representantes al siguiente
                            número:</h2>
                    </div>
                    <p class="contact">
                        Tel:
                    </p>
                    <p class="contact bold">
                        <a href="tel:8002230323">800 2230 323</a>
                    </p>
                    <p class="contact">
                        o por WhatsApp al siguiente número:
                    </p>
                    <p class="contact bold">
                        <a href="https://api.whatsapp.com/send?phone=5215526659500" target="_blank">+52 1 5526659500</a>
                    </p>
                    <p style="padding: 15px 0 10px;"><br>* FAD® no almacena ningún documento firmado, el usuario es responsable de almacenar los archivos generados en
                        el proceso de firma.</p>
                </div>
                <div class="image">
                    <img src="assets/images/3_opciones.png" alt="Suscripciones">
                </div>
            </div>
        </div>

        <div class="form-container">
            <div class="side-panel">
                <div class="absolute">
                    <p>Envíanos tus datos para <br> <span>atender tu situación:</span></p>
                </div>
            </div>
            <div class="form" id="form-support">
                <p class="title-1">
                    También puedes <span>contactarnos</span> a través del siguiente <span>formulario:</span>
                </p>
                <form [id]="idForm"></form>
            </div>
        </div>
    </div>

    <!-- FAD MASIVO RESPONSIVO -->
    <div class="fad-movil" id="main" #main *ngIf=" isMobile === true || isTablet === true ">
        <div class="box-container">
            <div class="box-img">
            </div>
            <div class="content-res">
                <h1>¿Tienes alguna duda <span>o necesitas ayuda?</span></h1>
                <h2><p class="text">
                    Ponte en contacto con uno de nuestros representantes al <strong>Tel: <a href="tel:8002230323">800
                    2230 323</a></strong>
                    o por <strong> WhatsApp:<br><a href="https://api.whatsapp.com/send?phone=5215526659500"
                                                   target="_blank">+52 1 5526659500</a></strong>
                </p></h2>
                <p class="text" style="padding: 10px 0;">* FAD® no almacena ningún documento firmado, el usuario es responsable de almacenar los archivos generados en
                    el proceso de firma.</p>
            </div>

            <div class="box-light-fondo">
                <div class="wrapper">
                    <div class="content-res" style="padding-bottom: 0;">
                        <p class="light" style="margin-bottom: 0;"><span>Envíanos tus datos para</span> atender tu
                            situación: </p>
                    </div>
                    <div class="form" id="form-support-movil">

                    </div>
                </div>
            </div>
        </div>
    </div>

</app-template>
